import Vuex from 'vuex';
import { RootState } from './store/rootState';
import { StoreOptions } from 'vuex';
import { activityDefinitionStore } from './store/activityDefinition/activityDefinitionStore';
import { configStore } from './store/config/configStore';
import { enumStore } from './store/enum/enumStore';
import { userStore } from './store/user/userStore';
import { AxiosStatic } from 'axios';

const store: StoreOptions<RootState> = {
  state: {
    version: '1',
  },
  modules: {
    activityDefinitionStore,
    configStore,
    enumStore,
    userStore,
  },
  mutations: {
    updateVersion(state: RootState, version: string) {
      state.version = version;
    },
  },
  actions: {
    async getVersion({ commit }, { $http }: { $http: AxiosStatic }) {
      try {
        const response = await $http.get('version');
        commit('updateVersion', response.data);
      } catch (error) {
        console.error('Failed to fetch API version:', error);
        commit('updateVersion', '1');
      }
    },
  },
  getters: {},
};
export default new Vuex.Store<RootState>(store);
